import { Loading as RALoading } from "react-admin";

export const Loading = (props) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <RALoading {...props} />
    </div>
  );
};
